import Style from './style'
import defaultAvatar from 'shared/assets/avatar.svg'
import verifyShield from 'shared/assets/shield-icon.svg'

const PlayerInfo = ({
	nickname,
	name,
	phoneNumber,
	playerId,
	qualification,
	isVerified = false,
	avatarUrl,
}) => {
	return (
		<Style.Container>
			<Style.InfoSection>
				<Style.AvatarSection>
					<Style.Avatar
						src={avatarUrl && avatarUrl.length ? avatarUrl : defaultAvatar}
						alt={`${name} avatar`}
					/>
					<Style.Nickname>{nickname}</Style.Nickname>
				</Style.AvatarSection>
				<Style.DetailsSection>
					<Style.NameRow>
						<Style.Name>{name}</Style.Name>
						{isVerified && <img src={verifyShield} alt='shield' />}
					</Style.NameRow>
					<Style.PhoneNumber>{phoneNumber}</Style.PhoneNumber>
					<Style.PlayerId>IDX: {playerId}</Style.PlayerId>
				</Style.DetailsSection>
			</Style.InfoSection>

			<Style.QualificationSection>
				{qualification && (
					<Style.QualificationBadge>
						<Style.QualificationText>{qualification}</Style.QualificationText>
					</Style.QualificationBadge>
				)}
			</Style.QualificationSection>
		</Style.Container>
	)
}

export default PlayerInfo
